<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-panel-tab-section tab-section">
    <div v-if="(sectionData.displayValue || sectionData.displayValue === 0) && sectionData.displayValue!='N/A'">
      <wy-panel-tab-section-top :sectionData="sectionData" />
        <div v-if="sectionData && !sectionData.multiChart && sectionData.lineChartData" class="bottom-right-flex">
          <div class="chart-header">
          </div>
          <wy-panel-line-chart ref="lineChart" :chartId="panelId + '_' + sectionData.key + '_line_chart'" :lineChartData="sectionData.lineChartData" :tabBottomSection="this.$refs.tabBottomSection" :type="controller.dateRange" />
        </div>

        <div v-if="sectionData && !sectionData.multiChart && sectionData.pieChartData && sectionData.columnChartData" class="panel-body-flex">
          <div class="div-pie-section">
            <wy-panel-pie-chart ref="pieChart" :chartId="panelId + '_' + sectionData.key + '_pie_chart'" :pieChartData="sectionData.pieChartData" />
          </div>
          <div class="div-column-section">
            <wy-panel-column-chart ref="columnChart" :chartId="panelId + '_' + sectionData.key + '_column_chart'" :columnChartData="sectionData.columnChartData" :tabBottomSection="this.$refs.tabBottomSection" :type="controller.dateRange" />
          </div>
        </div>
        <div v-if="sectionData && sectionData.multiChart && sectionData.lineChartData && sectionData.columnChartData" class="panel-body-flex">
          <div class="div-pie-section">
            <wy-panel-pie-chart ref="pieChart" :chartId="panelId + '_' + sectionData.key + '_pie_chart'" :pieChartData="sectionData.pieChartData" />
          </div>
          <div class="div-column-section">
            <wy-panel-line-column-chart ref="comboChart" :controller="module" :chartId="panelId + '_' + sectionData.key + '_column_chart'" 
              :lineChartData="sectionData.lineChartData" :columnChartData="sectionData.columnChartData"  :type="controller.dateRange" :tabBottomSection="this.$refs.tabBottomSection" :legendColors="sectionData.pieChartData.legendColors" />
          </div>
        </div>
    </div>
      
    <div v-else class="no-data-flex"> 
      
        <div v-if="sectionData && !sectionData.multiChart && sectionData.lineChartData" class="panel-top-title">
          {{sectionData.lineChartData.title}}
          <el-tooltip popper-class="sub-header-info-poppers" class="item" effect="dark" placement="bottom">
            <div slot="content"><span v-html="sectionData.lineChartData.tooltips"></span></div>
            <div class="no-data-icon-info-small"></div>
          </el-tooltip>
        </div>

        <div v-if="sectionData && !sectionData.multiChart && sectionData.pieChartData" class="panel-top-title">
          {{sectionData.pieChartData.title}}
          <el-tooltip popper-class="sub-header-info-poppers" class="item" effect="dark" placement="bottom">
            <div slot="content"><span v-html="sectionData.pieChartData.tooltips"></span></div>
            <div class="no-data-icon-info-small"></div>
          </el-tooltip>
        </div>
        
        <img class="no-data-image" src="../../assets/icons/icon_performance_no_data.svg" alt="no data icon">
        <span class="no-data-text">Sorry!</span>
        <span class="no-data-text-small">No data available yet.</span>
      </div>
    
      <wy-panel-tab-section-bottom v-show="(sectionData.displayValue || sectionData.displayValue === 0) && sectionData.displayValue!='N/A'" ref="tabBottomSection" :controller="controller" :legendData="legendData" :sectionData="sectionData" :parent="module" /> 

  </div>

</template>

<script>
  import Vue from 'vue';
  import WyPanelTabSectionTop from './wy-panel-tab-section-top.vue';
  import WyPanelTabSectionBottom from './wy-panel-tab-section-bottom.vue';
  import WyPanelLineChart from './panel-charts/wy-panel-line-chart.vue';
  import WyPanelColumnChart from './panel-charts/wy-panel-column-chart.vue';
  import WyPanelPieChart from './panel-charts/wy-panel-pie-chart.vue';
  import WyPanelLineColumnChart from './panel-charts/wy-panel-line-column-chart.vue';
  

  export default Vue.extend({
    name: 'wy-panel-tab-section',
    props: ['controller', 'sectionData', 'panelId', 'legendData'],
    components: {
      'wy-panel-tab-section-top': WyPanelTabSectionTop,
      'wy-panel-tab-section-bottom': WyPanelTabSectionBottom,
      'wy-panel-line-chart': WyPanelLineChart,
      'wy-panel-column-chart': WyPanelColumnChart,
      'wy-panel-pie-chart': WyPanelPieChart,
      'wy-panel-line-column-chart': WyPanelLineColumnChart
    },

    data() {
      return {
        module: this,
        selectedDateRange: 'days'
      }
    },

    created() {
      // console.log(this.controller)
      // if(this.controller.sectionData.lineChartData) {
      //   this.legendData['legends'] = this.controller.sectionData.lineChartData.legends
      // }
      // if(this.controller.sectionData.pieChartData) {
      //   this.controller.legendData['legends'] = this.controller.sectionData.pieChartData.legends
      // }
    }

  });
</script>

<style lang="scss">
    .icon-info-small{
      display: inline-block;
      background: url('../../assets/icons/icon_info_small.svg') no-repeat;
      width: 20px;
      height: 21px;
      position: relative;
      top: 0.8vw;
      right: 0.29vw;
      margin-left: 0.36vw;
    }
    .no-data-icon-info-small{
      display: inline-block;
      background: url('../../assets/icons/icon_info_small.svg') no-repeat;
      width: 20px;
      height: 21px;
      position: relative;
      top: 10px;
      right: 0.29vw;
      margin-left: 0.36vw;
    }
    .no-data-flex{
      display: flex;
      min-height: 495px;
      height: 1vw;
      flex-direction: column;
      align-items: flex-start;
    }
    .no-data-image{
      margin-top: 10% !important;
      margin-left: 39.5%;
      width: 21%;
    }
    .panel-top-title{
      font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
      padding: 15px 15px 0 15px;
      font-size: 14.5px;
      font-weight: medium;
      color: var(--site-font-secondary-color);
    }
    .no-data-text{
      font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
      font-size: 18px;
      color: var(--site-font-tertiary-color);
      font-weight: 500;
      margin-left: 0.2vw;
      width: 100%;
      text-align: center;
      margin-top: 1.33vw;
    }
    .no-data-text-small{
      font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
      font-size: 14.5px;
      color: var(--site-font-tertiary-color);
      margin-top: 1.07vw;
      font-weight: 400;
      margin-left: 0.2vw;
      margin-bottom: 4.44vw;
      width: 100%;
      text-align: center;
    }
  .wy-panel-tab-section.tab-section {
    .table-filter-dropdown.date-range {
      width: 8.53vw;
      left: 0px !important;
    }

    .panel-body-flex{
      width: 100%;
      // border-bottom: 1px #CAD2DA solid;
      // height: 300px;
      display: flex;
      // flex-direction: column;
      .div-pie-section {
        // border-right: 1px #CAD2DA solid;
        width: 45%;
      }
      .div-column-section {
        width: 55%;
      }
    }
    .view-by {
      position: relative;
      right: 42px;
      top: -10px;
      float: right;
      font-size: 12px;
      font-weight: 400;
    }
    .view-by-column {
      position: relative;
      right: 22px;
      top: -10px;
      float: right;
      font-size: 12px;
      font-weight: 400;
    }
    .div-column-section {
      .scrollable-mode{
        position: relative;
        right: -26%;
        top: 7px;
        font-size: 12px;
        font-weight: 400;
        width: 200px;
        height:20px;
        .el-switch__label * {
          font-size: 12px !important;
          font-weight: 400;
        }
        .el-switch__core {
          background: #E1E5E9;
        }
        .el-switch__label--right {
          margin-left: 5px;
        }
      }
    }
    //#1c4db2
    .scrollable-mode{
      position: relative;
      right: -45%;
      top: 7px;
      font-size: 12px;
      font-weight: 400;
      width: 200px;
      height:20px;
      .el-switch__label * {
        font-size: 12px !important;
        font-weight: 400;
      }
      .el-switch.is-checked .el-switch__core {
        border-color: #106FBC;
        background-color: #106FBC;
      }
      .el-switch__label.is-active {
        color: #4B5158;
      }
      .el-switch__core {
        background: #E1E5E9;
      }
      .el-switch__label--right {
        margin-left: 5px;
      }
    }
  }

  // @media screen  and (min-width: 2000px) {
  //   .wy-panel-tab-section.tab-section {
  //     .view-by {
  //       position: relative;
  //       right: 60px;
  //       top: -10px;
  //       float: right;
  //       font-size: 12px;
  //     }
  //   }
  // }
</style>